"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationContent',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        submit: '提交',
        publish: '发布',
        reject: '拒绝',
        offline: '下架',
        view: '浏览',
        like: '点赞',
        favorite: '收藏'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationContentListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('案例标题', '新案例').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationContentSaveApi)({
          title: value || '现代简约样板',
          contentType: 'case',
          communityName: '翠湖苑',
          summary: '南北通透三居',
          sourceType: 'original'
        }).then(function () {
          _this2.$message.success('案例已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
        (0, _decoration.decorationContentActionApi)(row.content.id, {
          action: action
        }).then(function () {
          _this3.$message.success('内容已更新');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};